'use strict';

import { EventEmitter } from "events";


export class IMEvent {
  static EVENT_FRIEND_LIST = "S2C_MSG_FRIEND_LIST_REP";
  static GROUP_INFO_CHANGE = "GROUP_INFO_CHANGE";
  static FRIEND_APPLY_LIST = "S2C_MSG_FRIEND_APPLY_LIST_REP";
  static FRIEND_APPLY_BACK = "S2C_MSG_HANDLE_FRIEND_APPLY_REP";
  static UPDATE_CONVERSATION_LIST = "UPDATE_CONVERSATION_LIST";
  static EVENT_MESSAGE_RECEIVED = "EVENT_MESSAGE_RECEIVED";
  static ADD_GROUP_MEMBER_RESPONSE = "S2C_MSG_ADD_GROUP_MEMBER_REP";
  static DEL_GROUP_MEMBER_RESPONSE = "S2C_MSG_DEL_GROUP_MEMBER_REP";
  static JOIN_ROOM_CHAT_REP = "JOIN_ROOM_CHAT_REP";
  static QUIT_ROOM_CHAT_REP = "QUIT_ROOM_CHAT_REP";
  static CHAT_ROOM_LIST = "CHAT_ROOM_LIST";
  static CHAT_ROOM_ZHA = "CHAT_ROOM_ZHA";
  static S2C_MSG_RED_NTY_APPLY_NUM = "S2C_MSG_RED_NTY_APPLY_NUM";
  static S2C_MSG_LOGIN_OTHER_NTY = 'S2C_MSG_LOGIN_OTHER_NTY';
  static S2C_MSG_DEL_CHATROOM_MSG_REP = 'S2C_MSG_DEL_CHATROOM_MSG_REP';

  static S2C_MSG_GET_USER_INFO_REP = "S2C_MSG_GET_USER_INFO_REP";
  static S2C_MSG_ADD_FRIEND_BYFID_REP = "S2C_MSG_ADD_FRIEND_BYFID_REP";
  static S2C_MSG_GET_CHATROOM_HISTORY_MSG_REP = "S2C_MSG_GET_CHATROOM_HISTORY_MSG_REP";
  static S2C_MSG_SEND_CHATROOM_AD_REP = "S2C_MSG_SEND_CHATROOM_AD_REP";

  static REF_ROOM = "REF_ROOM";
  static EVENT_MESSAGE_UNREAD_COUNT_CHANGE = "EVENT_MESSAGE_UNREAD_COUNT_CHANGE";
  static EVENT_MESSAGE_AD_CHAT = "EVENT_MESSAGE_AD_CHAT";
}

const IMEventEmitter = new EventEmitter();
IMEventEmitter.setMaxListeners(10000000000000000);
export default IMEventEmitter;
